import { Fragment, useMemo } from "react"
import { useMatches, Link } from "react-router"

import type { BreadcrumbMatch } from "@/utils/types"

const Breadcrumbs = () => {
  const matches = useMatches() as BreadcrumbMatch[]

  const breadcrumbs = useMemo(() => {
    if (!/\/applications/i.test(matches[matches.length - 1].pathname)) return []

    const breadcrumbs = [{ text: "Applications", path: "/applications" }]

    matches.forEach((match) => {
      if (match.handle == null) return
      const { app, breadcrumb } = match.handle

      if (app != null) breadcrumbs.push({ text: app, path: `/applications/${encodeURIComponent(app)}` })
      else if (breadcrumb != null) breadcrumbs.push({ text: breadcrumb(match), path: match.pathname })
    })

    return breadcrumbs
  }, [matches])

  if (breadcrumbs.length < 1) return null

  return (
    <nav className="flex items-center gap-2 text-sm text-muted-foreground">
      {breadcrumbs.map((crumb, index, arr) => (
        <Fragment key={crumb.path}>
          <span>/</span>
          {arr.length === index + 1 ? (
            <span role="link" aria-current="page" className="cursor-default font-medium text-foreground">
              {crumb.text}
            </span>
          ) : (
            <Link to={crumb.path} className="font-medium text-muted-foreground transition-colors hover:text-foreground">
              {crumb.text}
            </Link>
          )}
        </Fragment>
      ))}
    </nav>
  )
}

export default Breadcrumbs
